
import { Component, Prop, Vue } from 'vue-property-decorator';
import QRCode from 'qrcode';
import { DOWNLOAD_CLIENT_TYPE } from '../constant';

@Component
export default class PcVideoSection extends Vue {
  @Prop({ default: () => require('@/assets/video/rj.mp4') }) public videoSrc!: string;
  @Prop({ default: false }) public showIosDownload!: boolean;

  public downloadClientType = DOWNLOAD_CLIENT_TYPE;
  public url = window.location.href;
  public mounted() {
    QRCode.toCanvas(this.$refs.qrCanvasAndroid, this.url, { width: 155, height: 155 });
    QRCode.toCanvas(this.$refs.qrCanvasIos, this.url, { width: 155, height: 155 });
  }
}
